import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import TopReviewClient from "./TopReviewClient";
import OtherReviewClient from "./OtherReviewClient";
import { $crud } from "../../../utils/CrudFactory";

const ClientReviews = ({
  showAllReviews,
  onViewAllClick,
  filtrationData,
  dateFilter,
  setDateFilter,
}) => {
  const [reviews, setReviews] = useState([]);

  async function retrieveData() {
    const { data } = await $crud.retrieve("admin/client-reviews", {
      from: dateFilter.from,
      to: dateFilter.to,
    });
    setReviews(data.data);
  }

  useEffect(() => {
    retrieveData();
  }, [dateFilter.from, dateFilter.to, showAllReviews]);

  return (
    <>
      <Grid container sx={{ padding: "0 18px" }}>
        {!showAllReviews && (
          <Grid item xs={12} sx={{ marginTop: "10px" }}>
            <TopReviewClient />
          </Grid>
        )}
        <Grid item xs={12} sx={{ marginTop: "28px" }}>
          <OtherReviewClient
            showAllReviews={showAllReviews}
            onViewAllClick={onViewAllClick}
            filtrationData={filtrationData}
            dateFilter={dateFilter}
            setDateFilter={setDateFilter}
            reviews={reviews}
            setReviews={setReviews}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ClientReviews;
